<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DaraContainer',
  inheritAttrs: false,
  props: {
    size: String,
  },
  computed: {
    classes() {
      return [
        'dara-container', {
          [`dara-container--${this.size}`]: !!this.size,
        },
      ];
    },
  },
};
</script>
